export function locationSelector(state) {
  return state.ui.location
}
